module.exports = __webpack_public_path__ + "static/absorbed_in.c86a87e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/absorbed_in.png
// module id = 352
// module chunks = 154382131621592